import PropTypes from 'prop-types';
import React from 'react';

import { WaybillFilterQueryShape } from 'shapes/waybills';
import { gettext } from '../../utils/text';
import { FILTERS } from '../../ducks/filters';
import TableEntityFilter from '../Table/TableEntityFilter';

const WaybillTruckFilter = ({ truckNumber, changeTruckNumber, query }) => {
    return (
        <TableEntityFilter
            initialValue={truckNumber}
            onChange={changeTruckNumber}
            itemsToOptions={item => ({
                text: item,
                value: item,
            })}
            name="truck_filter"
            buttonPlaceholder={gettext('Select truck')}
            buttonLeftIcon="truck"
            filterType={FILTERS.WAYBILL.TRUCKS}
            query={query}
        />
    );
};

WaybillTruckFilter.propTypes = {
    truckNumber: PropTypes.string.isRequired,
    changeTruckNumber: PropTypes.func.isRequired,
    query: WaybillFilterQueryShape.isRequired,
};

export default WaybillTruckFilter;
